<template>
  <div>
    <div class="content-header">
      <h3>{{ t.allWorks.albums[$route.params.type] }}</h3>
    </div>
    <paginate 
        class="album-list"
        v-if="album_list_sorted.length" 
        ref="paginator" 
        name="albumlistPaginate"
        tag="div"
        :list="albums_list" 
        :per="12" 
        :refreshCurrentPage="true">
        <!-- item -->
        <div class="album-item" 
            v-for="(item,i) in paginated('albumlistPaginate')" 
            :key="i">
          <div class="album-image">
            <!-- image -->
              <progressive-img :src="thumb(item.CoverLink)">
              <div 
                  slot-scope="{visible}" 
                  v-if="visible" 
                  class="loading-spinner-flex" 
                  style="background:#fff">
                  aranıyor...
                <i class="diginity dg-loading diginity-is-spinning"></i>
              </div>
            </progressive-img>
          </div>
          <div class="album-info">
            <!-- Title / router -->
            <router-link :to="`${$route.path}/${item.ID}`">
              {{ item.Key }} - {{ new Date(item.Date).getFullYear() }}
            </router-link>
          </div>
        </div>
        <!--  /end item -->
    </paginate>
    <paginate-links 
        v-if="album_list_sorted.length" 
        for="albumlistPaginate" 
        :limit="3" 
        :show-step-links="true">
    </paginate-links>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      paginate: ['albumlistPaginate']
    };
  },
  computed: {
    ...mapGetters(['albums_list', 'lng', 't', 'file', 'thumb']),
    album_list_sorted() {
      return this.albums_list.sort((a, b) => {
        return new Date(b.Date) - new Date(a.Date);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.album-list {
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  flex: 1;
  .album-item {
    cursor: default;
    display: flex;
    flex-direction: column;
    padding: 5px 5px 30px;
    width: 33.333%;
    @media screen and (max-width: 560px) {
      width: 50%;
    }
    @media screen and (max-width: 480px) {
      width: 100%;
    }
    .album-image {
      text-align: center;
      margin-bottom: 5px;
      img {
        width: 100%;
      }
    }
    .album-info {
      flex: 1 auto;
      display: flex;
      border-top: 3px solid #949195;
      border-bottom: 2px solid #949195;
      font-size: 16px;
      justify-content: center;
      align-items: center;
      text-align: center;
      a {
        margin: 5px 0;
        font-size: 15px;
        color: #0078a0;
      }
    }
  }
}
</style>
